import { Component } from '@angular/core';

@Component({
    selector: 'app-nav-rail',
    templateUrl: './nav-rail.component.html',
    styleUrls: ['./nav-rail.component.scss'],
    standalone: true
})
export class NavRailComponent {

}
